import React from "react";
import { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useNavigate } from "react-router-dom";

const ReferCandidateStatus = () => {
  const [referedCandidate, setReferedCandidate] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");  
  const [apiStatus, SetApiStatus] = useState(undefined);
  const navigate = useNavigate();

  const fetchReferStatus = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}report/9`);
      SetApiStatus(response?.status);
      const apidata = response?.data?.data;
      setReferedCandidate(apidata);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  };
  useEffect(() => {
    fetchReferStatus();
  }, [searchTerm]);

  const columns = {
    FullName: { text: "Name",visible:true },
    JobTitle: { text: "Job Title",visible:true },
    SkillSet: { text: "Skills",visible:true },
    PrimaryTA: { text: "Primary TA",visible:true },
    AppliedDate: { text: "Applied Date",align:"center",visible:true},
    Status: { text: "Status",visible:true },
    JobStatus: { text: "Job Status", align:"center", visible:true },
    ScreeningRejectRemark :{text: "Reject Remark",visible:true }
  };
  const defaultColumns = {
    FullName: true,
    JobTitle: true,
    SkillSet: true,
    PrimaryTA: true,
    AppliedDate: true,
    Status: true,
    JobStatus: true,
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Referral Status"))
  }, [])

    const handleAdd = () => {
    navigate(`/refer-candidate/add`);
  }
  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
            <Dynamic_PR_table
              data={referedCandidate}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              isSorting={true}
              isAddNewBtnRequired={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              handleAddNew={handleAdd}
            />
            </div>
          </div>
        </div>
    </>
  );
};

export default ReferCandidateStatus;
